<div class="row">
  <div class="col-sm-4">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Invoice Year</mat-label>
      <mat-select panelClass="standard-modal-panel" [required]="ValuesRequired()" [(ngModel)]="Year" #year="ngModel" name="year" (selectionChange)="onYearSelected($event.value)" [disabled]="VendorId() == null">
        @if (!ValuesRequired()) {
          <mat-option [value]="null"></mat-option>
        }
        @for (year of Dropdowns.Years(); track year) {
          <mat-option [value]="year">{{year}}</mat-option>
        }
      </mat-select>
      @if (year.errors?.required) {
        <mat-error>
          Year is required
        </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="col-sm-4">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>PO</mat-label>
      <mat-select panelClass="standard-modal-panel" [required]="ValuesRequired()" [disabled]="PurchaseRequisitionNumber != null || Year == null || VendorId() == null" [(ngModel)]="PurchaseOrderNumber" #purchaseOrderNumber="ngModel" name="purchase-order-number" (selectionChange)="onPurchaseOrderNumberSelected($event.value)">
        @if (!ValuesRequired()) {
          <mat-option [value]="null"></mat-option>
        }
        @for (a of Dropdowns.PurchaseOrders(); track a) {
          <mat-option [value]="a.Number">{{a.Number}}</mat-option>
        }
      </mat-select>
      @if (purchaseOrderNumber.errors?.required) {
        <mat-error>
          Purchase Order is required
        </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="col-sm-4">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>PR (NOPO)</mat-label>
      <mat-select panelClass="standard-modal-panel" [required]="ValuesRequired()" [disabled]="PurchaseOrderNumber != null || VendorId() == null || Year == null" [(ngModel)]="PurchaseRequisitionNumber" #purchaseReqNumber="ngModel" name="purchase-req-number" (selectionChange)="onPurchaseRequisitionSelected($event.value)">
        @if (!ValuesRequired()) {
          <mat-option [value]="null"></mat-option>
        }
        @for (a of Dropdowns.PurchaseRequisitions(); track a) {
          <mat-option [value]="a.Number">{{a.Number}}</mat-option>
        }
      </mat-select>
      @if (purchaseReqNumber.errors?.required) {
        <mat-error>
          Purchase Requisition is required
        </mat-error>
      }
    </mat-form-field>
  </div>
</div>
